import { useState } from 'react';

import { Stack, Switch } from '@mui/material';

import { Label } from 'src/components/label';

type Props = {
  row: any;
  handleToggleStatus?: (row: any) => void;
  t: (key: string) => string;
};

export function RowCellWorkflowStatus({ row, handleToggleStatus, t }: Props) {
  const [isToggling, setIsToggling] = useState(false);

  const handleToggle = async () => {
    if (!handleToggleStatus) return;
    setIsToggling(true);
    await handleToggleStatus(row);
    setIsToggling(false);
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Switch
        size="small"
        checked={row.status === 'ACTIVE'}
        disabled={isToggling || !handleToggleStatus}
        onChange={(e) => {
          e.stopPropagation();
          handleToggle();
        }}
      />
      <Label
        variant="soft"
        color={
          (row.status === 'ACTIVE' && 'success') || (row.status === 'DRAFT' && 'warning') || 'error'
        }
        sx={{ textTransform: 'uppercase', fontSize: 10, fontWeight: 800, px: 1 }}
      >
        {t(row.status)}
      </Label>
    </Stack>
  );
}
